var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1309_18160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1309_18160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7642 14.4513L10.7603 12.4475C10.5766 12.5654 10.3847 12.669 10.1847 12.7583C9.98468 12.8476 9.77785 12.9269 9.56418 12.9961V12.2961C9.69407 12.2491 9.81907 12.2 9.93918 12.1486C10.0592 12.0974 10.1731 12.0372 10.2808 11.968L7.71801 9.40515V11.718L5.33335 9.33331H3.05135V6.66665H4.97951L1.72818 3.41531L2.20001 2.94348L13.2358 13.9795L12.7642 14.4513ZM12.2462 11.1103L11.7795 10.6436C12.0538 10.265 12.266 9.85043 12.416 9.39998C12.566 8.94954 12.641 8.47732 12.641 7.98332C12.641 7.0072 12.359 6.12515 11.7948 5.33715C11.2307 4.54915 10.4872 3.99359 9.56418 3.67048V2.97048C10.677 3.32437 11.5791 3.95965 12.2705 4.87632C12.962 5.79298 13.3077 6.82865 13.3077 7.98332C13.3077 8.56365 13.2143 9.11965 13.0275 9.65132C12.8408 10.1829 12.5804 10.6692 12.2462 11.1103ZM10.3975 9.26148L9.56418 8.42815V5.76148C9.94107 6.00593 10.2276 6.32776 10.4237 6.72698C10.6199 7.12609 10.718 7.55043 10.718 7.99998C10.718 8.22643 10.6913 8.44587 10.6378 8.65832C10.5844 8.87076 10.5043 9.07182 10.3975 9.26148ZM7.71801 6.58198L6.57435 5.42565L7.71801 4.28198V6.58198ZM7.05135 10.1V8.73848L5.64618 7.33332H3.71801V8.66665H5.61801L7.05135 10.1Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/muteIcon.9899f1b6ba6d83c53406e6da5cf81caa.svg";
export { ForwardRef as ReactComponent };